import { Link } from 'react-router-dom'
import { deckMetadata } from '@/decks/registry'
import { DeckThumbnail } from '@/components/DeckThumbnail'
import './HomePage.css'

// Oldest → newest. Static data, so sort once at module scope.
const decksByDate = [...deckMetadata].sort((a, b) => a.date.localeCompare(b.date))

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Format an ISO 'YYYY-MM-DD' as "Mar 26, 2026" without Date() timezone drift.
function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-')
  const month = MONTHS[parseInt(m, 10) - 1] ?? ''
  return `${month} ${parseInt(d, 10)}, ${y}`
}

function GCLogo() {
  return (
    <svg width="40" height="40" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg" className="home-gc-icon" aria-hidden="true">
      <path fill="#FF5A2C" d="M75,150c-41.5,0-75-33.7-75-75.2c0-1.3,0-2.5,0.1-3.8C2.1,31.8,34.7,0.5,74,0c22.7-0.4,44.3,9.6,58.7,27.1c0.9,1.1,0.8,2.8-0.3,3.7c0,0-0.1,0.1-0.1,0.1l-8,6.1c-1.1,0.9-2.7,0.7-3.6-0.4C109.3,22.9,92.2,15,74.3,15.3c-32.9,0.4-59.5,27.8-59,60.7c0.6,33,27.8,59.2,60.7,58.7c17.2-0.3,33.4-8,44.5-21.1c0.9-1.1,2.5-1.2,3.6-0.4l7.9,6.2c1.1,0.9,1.4,2.5,0.5,3.7c0,0-0.1,0.1-0.1,0.1C118.3,140.2,97.2,150.1,75,150z"/>
      <path fill="#FF5A2C" d="M75.1,119.3c-24.5,0-44.3-19.8-44.3-44.3c0-24.5,19.8-44.3,44.3-44.3c12.8,0,25,5.6,33.4,15.2c0.9,1.1,0.8,2.8-0.3,3.7c0,0-0.1,0.1-0.1,0.1l-7.9,6.2c-1.1,0.9-2.7,0.7-3.6-0.3c-10.7-11.9-29.1-12.8-40.9-2s-12.8,29.1-2,40.9c10.7,11.9,29.1,12.8,40.9,2c3.2-2.9,5.6-6.4,7.3-10.3H83.6c-1.4,0-2.6-1.2-2.6-2.6v-10c0-1.4,1.2-2.6,2.6-2.6h33.3c1.4,0,2.6,1.2,2.6,2.6c0,0,0,0.1,0,0.1c-0.1,3.1-0.4,5.6-0.4,5.6C117.1,102,98,119.4,75.1,119.3z"/>
    </svg>
  )
}

export function HomePage() {
  return (
    <div className="home-page">
      <header className="home-header">
        <GCLogo />
        <div className="home-header-text">
          <h1>GC Slides</h1>
          <p className="home-subtitle">GlobalComix presentations &middot; {decksByDate.length} decks</p>
        </div>
      </header>

      <ul className="home-grid">
        {decksByDate.map(deck => (
          <li key={deck.slug}>
            <Link to={`/deck/${deck.slug}`} className="home-card">
              <DeckThumbnail slug={deck.slug} title={deck.title} />
              <div className="home-card-body">
                <h2 className="home-card-title">{deck.title}</h2>
                <p className="home-card-subtitle">{deck.subtitle}</p>
                <div className="home-card-meta">
                  <time className="home-card-date" dateTime={deck.date}>{formatDate(deck.date)}</time>
                  <span className="home-card-cta">Open &rarr;</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
